import { render, staticRenderFns } from "./WizardChavePadrao.vue?vue&type=template&id=ac7c28fe&"
import script from "./WizardChavePadrao.vue?vue&type=script&lang=js&"
export * from "./WizardChavePadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports